<template>
  <div class="main">
    <svg
      t="1684919303288"
      class="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="4276"
      width="200"
      height="200"
    >
      <path
        d="M512 337.322667a26.666667 26.666667 0 0 1-26.666667-26.666667V197.333333a26.666667 26.666667 0 1 1 53.333334 0v113.322667c0 14.762667-11.946667 26.666667-26.666667 26.666667z"
        fill="#ffffff"
        p-id="4277"
      ></path>
      <path
        d="M424.661333 360.746667a26.666667 26.666667 0 0 1-36.394666-9.728l-56.661334-98.133334a26.666667 26.666667 0 0 1 46.122667-26.666666l56.661333 98.133333a26.624 26.624 0 0 1-9.728 36.394667z"
        fill="#ffffff"
        opacity=".9"
        p-id="4278"
      ></path>
      <path
        d="M360.746667 424.661333a26.624 26.624 0 0 1-36.394667 9.728l-98.133333-56.661333a26.624 26.624 0 1 1 26.666666-46.122667l98.133334 56.661334c12.714667 7.338667 17.066667 23.68 9.728 36.394666z"
        fill="#ffffff"
        opacity=".85"
        p-id="4279"
      ></path>
      <path
        d="M337.322667 512c0 14.72-11.946667 26.666667-26.666667 26.666667H197.333333a26.666667 26.666667 0 1 1 0-53.333334h113.322667c14.762667 0 26.666667 11.946667 26.666667 26.666667z"
        fill="#ffffff"
        opacity=".8"
        p-id="4280"
      ></path>
      <path
        d="M360.746667 599.338667a26.666667 26.666667 0 0 1-9.728 36.394666l-98.133334 56.661334a26.666667 26.666667 0 0 1-26.666666-46.122667l98.133333-56.661333a26.624 26.624 0 0 1 36.394667 9.728z"
        fill="#ffffff"
        opacity=".75"
        p-id="4281"
      ></path>
      <path
        d="M424.661333 663.253333a26.624 26.624 0 0 1 9.728 36.394667l-56.661333 98.133333a26.624 26.624 0 1 1-46.122667-26.666666l56.661334-98.133334a26.666667 26.666667 0 0 1 36.394666-9.728z"
        fill="#ffffff"
        opacity=".7"
        p-id="4282"
      ></path>
      <path
        d="M512 686.677333c14.72 0 26.666667 11.946667 26.666667 26.666667v113.322667a26.666667 26.666667 0 1 1-53.333334 0v-113.322667c0-14.762667 11.946667-26.666667 26.666667-26.666667z"
        fill="#ffffff"
        opacity=".65"
        p-id="4283"
      ></path>
      <path
        d="M599.338667 663.253333a26.666667 26.666667 0 0 1 36.394666 9.728l56.661334 98.133334a26.666667 26.666667 0 0 1-46.122667 26.666666l-56.661333-98.133333a26.624 26.624 0 0 1 9.728-36.394667z"
        fill="#ffffff"
        opacity=".6"
        p-id="4284"
      ></path>
      <path
        d="M663.253333 599.338667a26.624 26.624 0 0 1 36.394667-9.728l98.133333 56.661333a26.624 26.624 0 1 1-26.666666 46.122667l-98.133334-56.661334a26.666667 26.666667 0 0 1-9.728-36.394666z"
        fill="#ffffff"
        opacity=".55"
        p-id="4285"
      ></path>
      <path
        d="M686.677333 512c0-14.72 11.946667-26.666667 26.666667-26.666667h113.322667a26.666667 26.666667 0 1 1 0 53.333334h-113.322667a26.666667 26.666667 0 0 1-26.666667-26.666667z"
        fill="#ffffff"
        opacity=".5"
        p-id="4286"
      ></path>
      <path
        d="M663.253333 424.661333a26.666667 26.666667 0 0 1 9.728-36.394666l98.133334-56.661334a26.666667 26.666667 0 0 1 26.666666 46.122667l-98.133333 56.661333a26.624 26.624 0 0 1-36.394667-9.728z"
        fill="#ffffff"
        opacity=".4"
        p-id="4287"
      ></path>
      <path
        d="M599.338667 360.746667a26.624 26.624 0 0 1-9.728-36.394667l56.661333-98.133333a26.624 26.624 0 1 1 46.122667 26.666666l-56.661334 98.133334a26.666667 26.666667 0 0 1-36.394666 9.728z"
        fill="#ffffff"
        opacity=".3"
        p-id="4288"
      ></path>
    </svg>
  </div>
</template>
<script>
export default {
  name: "cancel",
  data() {
    return {};
  },
  created() {
    if (localStorage.getItem("orderDetail")) {
      this.$router.push({
        path: "/myOrderDetail",
        query: { id: localStorage.getItem("orderDetail"), sourceType: 1 },
      });
      localStorage.removeItem("orderDetail");
    } else {
      var item = JSON.parse(localStorage.getItem("paymentDate"));
      //视频为true 文章为fasle
      if (item.isCourse) {
        // if (!item.isFree && !item.isPay) {
        //   this.$router.push(`/coursePlateNopay/${item.courseId}?sourceType=1`);
        //   return;
        // } else {
        this.$storage.setStore("courseInfo", item);
        this.$router.push(`/coursePlate/${item.courseId}?sourceType=1`);
        return;
        // }
      }
      var showVideoPng = localStorage.getItem("paymentShowVideoPng");
      if (showVideoPng || item.type == "VIDEO") {
        this.$router.push({
          name: "video",
          query: {
            from: 1,
            sourceType: 1,
            videoId: item.id,
            courseId: item.courseId,
          },
        });
        var videoInfos = JSON.parse(localStorage.getItem("paymentvideoInfos"));
        this.$storage.setStore("videoInfo", item);
        this.$storage.setStore("videoInfos", videoInfos);
        localStorage.removeItem("paymentShowVideoPng");
      } else {
        this.$router.push({ name: "artical", query: { sourceType: "1" } });
        this.$storage.setStore("videoInfo", item);
      }
    }
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.main {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: rgba($color: #000000, $alpha: 0.3);
  svg {
    width: 50px;
    height: 50px;
    position: relative;
    top: 50%;
    margin-top: -25px;
    left: 50%;
    margin-left: -25px;
  }
}
</style>
<style>
@-webkit-keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(360deg);
  }
}
svg {
  -webkit-transform: rotate(360deg);

  animation: rotation 3s linear infinite;

  -moz-animation: rotation 3s linear infinite;

  -webkit-animation: rotation 3s linear infinite;

  -o-animation: rotation 3s linear infinite;
}
</style>
